export default __webpack_public_path__ + "static/media/sc43.b6d9d6e1.mp4";